import { searchContactsByOrganisation } from '../infrastructure/adapters/contactService';
import { useSearch } from '@/shared/composables/useSearch';
// View ids defined in OrganisationContactsTab — mapped to their includeEnded value.
// Any id not in this map defaults to false (active relations only).
const VIEW_INCLUDE_ENDED = {
    'org-contacts-all': true,
};
export function useOrganisationContacts(organisationId, tableQuery) {
    const { items: contacts, pageResponse, loading, loadError, reload } = useSearch((params) => searchContactsByOrganisation(organisationId(), {
        ...params,
        includeEnded: VIEW_INCLUDE_ENDED[params.filterId ?? ''] ?? false,
    }), tableQuery, 'contacts');
    return { contacts, pageResponse, loading, loadError, reload };
}
